import React from "react";
import { Link } from "react-router-dom";
import { useApp } from "../AppContext";
import DominicanFlag from "./DominicanFlag";
import DevBranding from "./DevBranding";

const Footer = () => {
    const { t, lang, branding } = useApp();
    const cuisineLabel =
        (lang === "es"
            ? branding.country_preset?.cuisine_label_es
            : branding.country_preset?.cuisine_label_en) ||
        t.footer.dominicanProud;
    return (
        <footer
            data-testid="footer"
            className="relative bg-earth-50 border-t border-earth-200 py-10"
        >
            {/* Country flag stripe (top edge) */}
            {branding.decorations_enabled && (
                <div className="absolute top-0 left-0 right-0 h-1 flex">
                    <div className="flex-1" style={{ background: "var(--flag-1)" }} />
                    <div className="flex-1" style={{ background: "var(--flag-2)" }} />
                    <div className="flex-1" style={{ background: "var(--flag-3)" }} />
                </div>
            )}
            <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 flex flex-col md:flex-row gap-6 items-center justify-between">
                <div className="flex items-center gap-3">
                    <div
                        className="relative w-10 h-10 rounded-full flex items-center justify-center text-white font-serif font-bold"
                        style={{ background: branding.brand_color_primary }}
                    >
                        {branding.brand_initials}
                        {branding.decorations_enabled && (
                            <DominicanFlag className="absolute -bottom-1 -right-1 w-4 h-3 rounded-sm shadow ring-1 ring-white" />
                        )}
                    </div>
                    <div>
                        <div className="font-serif font-bold text-earth-900 text-sm">
                            {branding.brand_name}
                        </div>
                        <div className="text-xs text-earth-600">{branding.brand_tagline}</div>
                        {branding.decorations_enabled && (
                            <div
                                className="text-[10px] uppercase tracking-wider font-bold mt-0.5"
                                style={{ color: "var(--flag-1)" }}
                            >
                                ❤ {cuisineLabel}
                            </div>
                        )}
                    </div>
                </div>
                <div className="flex items-center flex-wrap gap-x-6 gap-y-2 text-xs text-earth-600">
                    <Link
                        to="/track"
                        data-testid="footer-track-link"
                        className="hover:text-terracotta-600 transition-colors"
                    >
                        {t.tracking.title}
                    </Link>
                    <Link
                        to="/admin/login"
                        data-testid="footer-admin-link"
                        className="hover:text-terracotta-600 transition-colors"
                    >
                        {t.nav.admin}
                    </Link>
                    <span>
                        © {new Date().getFullYear()} {branding.brand_name}. {t.footer.rights}
                    </span>
                </div>
            </div>
            <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 mt-6 pt-4 border-t border-earth-200 text-center">
                <DevBranding variant="footer" />
            </div>
        </footer>
    );
};

export default Footer;
